/* @flow */
import {applyMiddleware, createStore, compose} from 'redux'
import middlewares from './middlewares'
import rootReducer from './rootReducer'

import type {Store, StoreEnhancer} from 'redux'
import type {State, Action} from 'modules/Common/types'

type Composer = typeof compose;

/**
 * __REDUX_DEVTOOLS_EXTENSION_COMPOSE__ is only available in development mode
 * if you install and plug remote redux devtools in
 *
 * https://github.com/zalmoxisus/remote-redux-devtools
 */
const composeEnhancers: Composer = global.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose

const enhancer: StoreEnhancer<State, Action<*>> = composeEnhancers(
  applyMiddleware(...middlewares)
  /* Other store enhancers */
)

const store: Store<State, Action<*>> = createStore(rootReducer, enhancer)

export default store
